var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('newsletter-form',{attrs:{"title":"newsletters.edit","initialData":_vm.model,"mode":"edit"},on:{"save":_vm.save,"cancel":_vm.cancel,"sync":_vm.sync}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }